export default "<app-basic-additional-information></app-basic-additional-information>\n";